import { PontCore } from '@/services/pontCore';
import { responseInterceptor } from '@/utils/responseInterceptor';
import { usePasswordless, useTokens } from '@verifime/cognito-passwordless-auth';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { api } from '@/utils/api';
import { interceptorWithToken } from '@verifime/api-definition';

export default function AuthenticatedContainer({ children }: { children: React.ReactElement }) {
  const { tokensParsed } = usePasswordless();
  const { getTokens, getTokensParsed } = useTokens();
  const router = useRouter();

  React.useEffect(() => {
    const validateTokensParsed = (tokensParsedToValidate: typeof tokensParsed) =>
      tokensParsedToValidate && new Date() < tokensParsedToValidate.expireAt;

    if (!validateTokensParsed(tokensParsed)) {
      getTokensParsed().then((newTokensParsed) => {
        if (!validateTokensParsed(newTokensParsed)) {
          const currentPath = router.pathname;
          if (currentPath !== '/') {
            router.push({
              pathname: '/',
              query: { from: encodeURIComponent(router.asPath) },
            });
          }
        }
      });
    }
  }, [getTokensParsed, router, tokensParsed]);

  PontCore.useFetch(async (url, options) => {
    const { accessToken: token } = (await getTokens()) || {};
    return await responseInterceptor(url, token, options);
  });

  useEffect(() => {
    api.use(
      interceptorWithToken({
        getToken: async () => getTokens().then(({ accessToken }) => accessToken),
      }),
    );
  }, [getTokens]);

  return <>{children} </>;
}
